/**
 * Modal de confirmación reutilizable
 * Sistema Klever Octopus - Betel Natural
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import '../../../styles/components/_modal.scss';

const ConfirmModal = ({
  isOpen,
  title = 'Confirmar acción',
  message = '¿Estás seguro de que deseas continuar?',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  confirmClass = 'btn-danger',
  cancelClass = 'btn-secondary',
  onConfirm,
  onCancel,
  loading = false
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (!loading) {
      onConfirm();
    }
  };

  const handleCancel = () => {
    if (!loading) {
      onCancel();
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCancel();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleCancel();
    } else if (e.key === 'Enter') {
      handleConfirm();
    }
  };

  React.useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'unset';
      };
    }
  }, [isOpen, loading]);

  return (
    <div
      className="modal-overlay"
      onClick={handleOverlayClick}
    >
      <div className="modal modal--small">
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button
            className="modal-close"
            onClick={handleCancel}
            disabled={loading}
            type="button"
          >
            <FiX size={24} />
          </button>
        </div>

        <div className="modal-content">
          <div className="confirm-modal-content">
            <div className="confirm-icon">
              <FiAlertTriangle size={48} />
            </div>

            <p className="confirm-message">{message}</p>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className={`btn ${cancelClass}`}
            onClick={handleCancel}
            disabled={loading}
          >
            {cancelText}
          </button>

          <button
            type="button"
            className={`btn ${confirmClass}`}
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-small"></span>
                Procesando...
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmClass: PropTypes.string,
  cancelClass: PropTypes.string,
  icon: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default ConfirmModal;
